import { Check, Circle, Loader2, ChevronRight } from "lucide-react";

function statusOf(percent) {
  if (percent >= 100) return "completed";
  if (percent > 0) return "progress";
  return "pending";
}

export default function PhaseRoadmap({ phases, progress, selectedId, onSelect }) {
  const perPhase = progress?.per_phase || {};

  return (
    <div className="rounded-2xl border border-border bg-card" data-testid="phase-roadmap">
      <div className="p-5 border-b border-border/70">
        <div className="caption mb-1">Hoja de ruta</div>
        <h3 className="text-lg font-semibold">Las 9 fases</h3>
      </div>
      <div className="p-2">
        {phases.map((phase) => {
          const p = perPhase[phase.id]?.percent || 0;
          const status = statusOf(p);
          const active = selectedId === phase.id;
          return (
            <button
              key={phase.id}
              data-testid={`phase-item-${phase.order}`}
              onClick={() => onSelect(phase.id)}
              className={`w-full text-left rounded-xl px-3 py-3 flex items-center gap-3 transition-all ${
                active ? "bg-accent border-l-[3px] border-primary" : "border-l-[3px] border-transparent hover:bg-background-subtle"
              }`}
            >
              <div
                className={`shrink-0 h-9 w-9 rounded-lg flex items-center justify-center font-mono text-sm font-semibold ${
                  status === "completed"
                    ? "bg-primary text-primary-foreground"
                    : status === "progress"
                    ? "bg-primary/15 text-primary"
                    : "bg-secondary text-muted-foreground"
                }`}
              >
                {status === "completed" ? (
                  <Check className="h-4 w-4" />
                ) : status === "progress" ? (
                  <Loader2 className="h-4 w-4" />
                ) : (
                  phase.order
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium truncate leading-tight">{phase.name}</div>
                <div className="mt-1.5 flex items-center gap-2">
                  <div className="h-1.5 flex-1 rounded-full bg-secondary overflow-hidden">
                    <div
                      className="h-full bg-primary rounded-full transition-all duration-700"
                      style={{ width: `${p}%` }}
                    />
                  </div>
                  <span className="font-mono text-xs text-muted-foreground w-9 text-right">{p}%</span>
                </div>
              </div>
              <ChevronRight className={`h-4 w-4 shrink-0 transition-colors ${active ? "text-primary" : "text-muted-foreground/50"}`} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
